import { motion } from "framer-motion";

export function AppStoreButton({ variant = "apple", onClick, testid, className = "" }) {
  if (variant === "apple") {
    return (
      <button
        onClick={onClick}
        data-testid={testid}
        className={`store-btn ${className}`}
        aria-label="Download on the App Store"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
        </svg>
        <div className="text-left leading-tight">
          <div className="text-[9px] tracking-wide opacity-80">Download on the</div>
          <div className="text-[15px] font-semibold -mt-0.5">App Store</div>
        </div>
      </button>
    );
  }
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`store-btn ${className}`}
      aria-label="Get it on Google Play"
    >
      <svg width="20" height="22" viewBox="0 0 24 26" aria-hidden>
        <defs>
          <linearGradient id="pg1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#00A0FF" />
            <stop offset="1" stopColor="#00E1FF" />
          </linearGradient>
          <linearGradient id="pg2" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#FFBD00" />
            <stop offset="1" stopColor="#FFE000" />
          </linearGradient>
          <linearGradient id="pg3" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#FF3A44" />
            <stop offset="1" stopColor="#C31162" />
          </linearGradient>
          <linearGradient id="pg4" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#32A071" />
            <stop offset="1" stopColor="#2DA771" />
          </linearGradient>
        </defs>
        <path d="M2 2v22l11-11L2 2z" fill="url(#pg1)"/>
        <path d="M13 13l4 4L4 24.6 13 13z" fill="url(#pg3)"/>
        <path d="M13 13l4-4L4 1.4 13 13z" fill="url(#pg4)"/>
        <path d="M17 9l4.4 2.4c1 .6 1 2 0 2.6L17 16l-4-3 4-4z" fill="url(#pg2)"/>
      </svg>
      <div className="text-left leading-tight">
        <div className="text-[9px] tracking-wide opacity-80">GET IT ON</div>
        <div className="text-[15px] font-semibold -mt-0.5">Google Play</div>
      </div>
    </button>
  );
}

export function AppStoreRow({ className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.1, duration: 0.7 }}
      className={`flex flex-wrap items-center gap-3 ${className}`}
    >
      <AppStoreButton variant="apple" testid="cta-app-store" />
      <AppStoreButton variant="google" testid="cta-play-store" />
    </motion.div>
  );
}
